import { render, staticRenderFns } from "./ApproveDenyDialog.vue?vue&type=template&id=400b5227&scoped=true&"
import script from "./ApproveDenyDialog.vue?vue&type=script&lang=js&"
export * from "./ApproveDenyDialog.vue?vue&type=script&lang=js&"
import style0 from "./ApproveDenyDialog.vue?vue&type=style&index=0&id=400b5227&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400b5227",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VCardText,VDialog})


/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
